var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.assetUrl,"download":_vm.assetFileName},domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":function($event){$event.preventDefault();return _vm.downloadAsset.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }